import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline, Box, CircularProgress, Typography, Button } from "@mui/material";
import theme from "./theme";
import { SessionProvider, useSession } from "./context/SessionContext";
import { OrderProvider } from "./context/OrderContext";
import MainLayout from "./components/MainLayout";
import Home from "./pages/Home";
import LiveOrder from "./pages/LiveOrder";
import Cart from "./pages/Cart";

function Tab({ children }) {
  return <MainLayout>{children}</MainLayout>;
}

// Gates the whole app on the store being resolved (GET get-store from this
// deployment's domain) and the anonymous guest token being minted (POST
// register) — see SessionContext. There's no login screen to fall back to
// here, so a failure (unknown domain, store deactivated, network down) is a
// dead end shown in place, with a retry rather than a redirect.
function SessionGate({ children }) {
  const { loading, error, ready } = useSession();

  if (loading) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100dvh", gap: 2 }}>
        <CircularProgress />
        <Typography color="text.secondary">Loading menu...</Typography>
      </Box>
    );
  }

  if (error || !ready) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100dvh", p: 3, textAlign: "center", gap: 2 }}>
        <Typography variant="h6" fontWeight={700}>
          Unable to load this store
        </Typography>
        <Typography color="text.secondary">{error || "Please scan the QR code on your table again."}</Typography>
        <Button variant="contained" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </Box>
    );
  }

  return children;
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SessionProvider>
        <SessionGate>
          <OrderProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Tab><Home /></Tab>} />
                <Route path="/live-order" element={<Tab><LiveOrder /></Tab>} />
                <Route path="/cart" element={<Cart />} />
              </Routes>
            </BrowserRouter>
          </OrderProvider>
        </SessionGate>
      </SessionProvider>
    </ThemeProvider>
  );
}
